import { PolygonPoints } from 'containers/AnnotationSystem/reducer';

export default function addPolygonPoint(
  polyPoints: PolygonPoints,
  newCoords: [number, number]
) {
  return [...polyPoints, newCoords];
}
